// @flow

import React, { Component } from 'react'
import styled from 'styled-components'
import type { ReactComponentStyled } from 'styled-components'

type ImageHeaderProps = {
    src: string,
    isImageContent?: boolean
}
const ImageHeaderContainer: ReactComponentStyled<{}> = styled.img`
  width: auto;
  height: 300px;
  @media only screen and (min-width : 320px) and (max-width : 823px){
    height: ${props => props.isImageContent ? '50vh' : '300px'};
    width: ${props => props.isImageContent ? 'auto' : 'auto'};
  }
  @media only screen and (max-width: 445px) {
    width: ${props => props.isImageContent ? 'auto' : `${props.onLoad}`};
    height: ${props => props.isImageContent ? '50vh' : 'auto'};
  }
  @media only screen and (max-height: 400px) {
    width: ${props => props.isImageContent ? 'auto' : 'auto'};
    height: ${props => props.isImageContent ? '50vh' : '200px'};
  }
`
ImageHeaderContainer.displayName = 'ImageHeaderContainer'
const ImageHeaderDiv: ReactComponentStyled<{}> = styled.div`
  text-align: center;
`
ImageHeaderDiv.displayName = 'ImageHeaderDiv'
class ImageHeader extends Component<ImageHeaderProps, {}> {
  handleOnImgLoad (e) {
    // This catches for square images
    const img = e.currentTarget
    let isSquareImage = '90%'
    if (img.naturalWidth === img.naturalHeight) {
      isSquareImage = '100%'
    }
    return isSquareImage
  }

  render () {
    const { src, isImageContent } = this.props
    return (
      <ImageHeaderDiv>
        <ImageHeaderContainer src={src} onLoad={this.handleOnImgLoad} isImageContent={isImageContent} />
      </ImageHeaderDiv>
    )
  }
}

export default ImageHeader
